import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CharacterLimitComponent } from "./character-limit.component";
import { FormsModule } from "@angular/forms";

@NgModule({
  declarations: [CharacterLimitComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [CharacterLimitComponent]
})
export class CharacterLimitModule { }
